import { useEffect } from 'react';
import { useAnalyticsConsent } from '@/context/AnalyticsConsentContext';
import {
  getPerformanceConsentGeneration,
  initializeFirebasePerformance,
  setFirebasePerformanceConsent,
} from '@/lib/firebase/performance-client';
import { startPerformanceWebVitals } from '@/lib/firebase/performance-web-vitals';

export const FirebasePerformance = () => {
  const { status } = useAnalyticsConsent();

  useEffect(() => {
    setFirebasePerformanceConsent(status === 'granted');
    if (getPerformanceConsentGeneration() === null) return;

    let idle: number | undefined;
    let timer: number | undefined;
    let stopWebVitals: (() => void) | undefined;
    const initialize = () => {
      void initializeFirebasePerformance();
      stopWebVitals = startPerformanceWebVitals();
    };
    const afterLoad = () => {
      if (typeof window.requestIdleCallback === 'function' && typeof window.cancelIdleCallback === 'function') {
        idle = window.requestIdleCallback(initialize, { timeout: 2000 });
      } else {
        timer = window.setTimeout(initialize, 0);
      }
    };
    if (document.readyState === 'complete') {
      afterLoad();
    } else {
      window.addEventListener('load', afterLoad, { once: true });
    }

    return () => {
      window.removeEventListener('load', afterLoad);
      if (idle !== undefined) window.cancelIdleCallback(idle);
      if (timer !== undefined) window.clearTimeout(timer);
      stopWebVitals?.();
      setFirebasePerformanceConsent(false);
    };
  }, [status]);

  return null;
};
